import { ConnextData } from "ngx-core-services";
import { SystemDefinition } from "../../state/system.state";

export const checkAndUpdateConnextSystemLocation = (system: SystemDefinition): SystemDefinition => {
  const connextData = system.data as Partial<ConnextData>;
  if (!connextData) {
    throw new Error('No connext data available');
  }
  return {
    ...system,
    metadata: {
      /** Default to Europe/Rome */
      ...system.metadata,
      tz: system.metadata?.tz ?? 2,
      structure: system.metadata?.structure ?? 2,
      isConnected: system.metadata?.isConnected,
      invertMeterSensor: system.metadata?.invertMeterSensor,
      location: {
        lat: connextData.config?.latitude?.toString() ?? '',
        lng: connextData.config?.longitude?.toString() ?? '',
      }
    },
  }
}

export const checkAndUpdateVirtualSystemLocation = (system: SystemDefinition): SystemDefinition =>{
  const coordinatesActZone = system.configuration.activeZone?.coordinates.split(',');
  let lng;
  let lat;
  if ( coordinatesActZone && coordinatesActZone.length > 1) {
    let longActZonePrecision = coordinatesActZone[1].trim().length - 1;
    let latActZonePrecision = coordinatesActZone[0].trim().length - 1;
    longActZonePrecision = longActZonePrecision > 0 ? longActZonePrecision : 1;
    latActZonePrecision = latActZonePrecision > 0 ? latActZonePrecision : 1;
    lng = Number(coordinatesActZone[1]).toPrecision(longActZonePrecision);
    lat = Number(coordinatesActZone[0]).toPrecision(latActZonePrecision);
  }

  return {
    ...system,
    metadata: {
      /** Default to Europe/Rome */
      ...system.metadata,
      tz: system.metadata?.tz ?? 2,
      structure: system.metadata?.structure ?? 2,
      isConnected: system.metadata?.isConnected,
      location: lat && lng ? { lat, lng } : undefined,
    },
  };
}

export const checkAndUpdateSystemLocation = (system: SystemDefinition): SystemDefinition => {
  if (system.monitoringType === 'Connext') {
    return checkAndUpdateConnextSystemLocation(system);
  }
  return checkAndUpdateVirtualSystemLocation(system);
}
